import React, {Fragment, useState, useEffect} from '../../../node_modules/react'
import axios from '../../../node_modules/axios';
import { Title, HeaderList, Cardlist,Container,Subtitle,Card } from './styles'
import globals from '../../../node_modules/react-global-configuration';

export const PatrocinadorItem = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    const [hasInCategoria, setHasInCategoria] = useState(false);
    
    

    const fetchData = async () => {
        const result = await axios(
            `${_URL_REST}/getpatrocinadores/${props.grupo}`,
        );
        setData(result.data)
    };
  
    useEffect(() => {
        fetchData();
    },[]);

    if (!data) {
        return <div></div>  
    }

    
    return (
        <Fragment>
               
                {
                    data
                    .map(item => 
                        <Card key={`item-${item.id}`}>
                            <a href={item.link} title={item.nombre} target="_blank"><img className="patrocinador" src={`${process.env.PUBLIC_URL}/${item.imagen}`} alt={item.nombre} /></a>
                        </Card>
                    )
                }
               
           
        </Fragment>
    )
}
